import Vue from 'vue'
import { vuexfireMutations } from 'vuexfire'

export default {
  SET_TOUCHABLE (state, value) {
    state.touchable = value
  },

  USER_REMOVE (state) {
    state.authLoading = false
    state.user = null
    state.userAccount = null

    state.accounts = []
    state.account = null
    state.accountArtworks = []
    state.accountArtwork = null
    state.accountArtist = null
    state.accountShow = null
    state.accountIteration = null
  },
  ACCOUNT_UPDATE (state, { user, account }) {
    state.userAccount = account
    state.user = user
    state.authLoading = false
  },

  REMOVE_ACCOUNT_ARTWORK (state) {
    state.accountArtwork = null
  },
  REMOVE_ACCOUNT_ARTIST (state) {
    state.accountArtist = null
  },
  REMOVE_ACCOUNT_SHOW (state) {
    state.accountShow = null
  },
  ...vuexfireMutations,

  SET_ITEMS: (state, { items }) => {
    items.forEach(item => {
      if (item) {
        Vue.set(state.items, item.__key, item)
      }
    })
  },
  SET_LOADING: (state, loading) => {
    state.loading = loading
  },

  /**
   * @param state
   * @param {string} artworkId
   * @param {number} configIndex
   * @param {DisplaySetup} config
   */
  UPDATE_DISPLAY_SETUPS (state, { artworkId, configIndex, config }) {
    if (!state.accountDisplaySetups) {
      state.accountDisplaySetups = {}
    }
    if (!state.accountDisplaySetups[artworkId]) {
      Vue.set(state.accountDisplaySetups, artworkId, [])
    }
    if (!configIndex || configIndex < 0) {
      state.accountDisplaySetups[artworkId].push(config)
    } else {
      Vue.set(state.accountDisplaySetups[artworkId], configIndex, config)
    }
  }
}
